import React from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./pin-anchor-positioning.module.scss";
import PinnedList from "../pinned-list";
import PinnedListHeader from "../pinned-list-header";
import VelavuItemIcon from "../../../../elements/velavu-item-icon";
import VelavuNotice from "../../../../elements/velavu-notice/velavu-notice";
import VelavuButton from "../../../../elements/velavu-button";
import { AnchorPositioningFeedback } from "../../../../state/pin-anchor-state";
import PinAnchorFeedbackSection from "./pin-anchor-feedback-section";

export interface PinAnchorPositioningProps {
	onClose?: () => void;
	deviceID: string;
	deviceModel: string | undefined;
	positioningFeedback?: AnchorPositioningFeedback;
	onNext?: () => void;
	isLoading?: boolean;
	disableNext?: boolean;
}

export default function PinAnchorPositioning(props: PinAnchorPositioningProps) {
	const { t } = useTranslation();

	return (
		<PinnedList>
			<PinnedListHeader
				label={t("dashboard.pin_anchor.positioning.header")}
				onClose={props.onClose}
			/>

			<div className={styles.content}>
				<div className={styles.deviceDetails}>
					<VelavuItemIcon data={{ model: props.deviceModel }} />

					<div className={styles.deviceDetailsText}>
						<span className={styles.deviceID}>
							{props.deviceID}
						</span>
						<span className={styles.deviceModel}>
							{props.deviceModel}
						</span>
					</div>
				</div>

				<VelavuNotice className={styles.info} type="info">
					{t("dashboard.pin_gateway.positioning.instructions")}
				</VelavuNotice>

				{props.positioningFeedback !== undefined && (
					<PinAnchorFeedbackSection
						className={styles.feedback}
						feedback={props.positioningFeedback}
					/>
				)}

				<div className={styles.buttonWrapper}>
					<VelavuButton
						label={t("common.confirm")}
						onClick={props.onNext}
						disabled={props.disableNext || props.isLoading}
						loadingIndicator={props.isLoading}
						fullWidth
					/>
				</div>
			</div>
		</PinnedList>
	);
}
